import { render, staticRenderFns } from "./Page4Chart1.vue?vue&type=template&id=ef0abe4a&scoped=true&"
import script from "./Page4Chart1.vue?vue&type=script&lang=ts&"
export * from "./Page4Chart1.vue?vue&type=script&lang=ts&"
import style0 from "./Page4Chart1.vue?vue&type=style&index=0&id=ef0abe4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0abe4a",
  null
  
)

export default component.exports